/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowBookbindingWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowBookbindingWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Bind Some Books!",
    "Bookbinding Awaits!",
    "Craft Your Own Story!",
  ],
  title: "Bookbinding Workshop",
  description: "Organize a creative bookbinding workshop.",
  longDescription:
    "Gather your friends for a fun bookbinding workshop! Choose a date, decide on book types to bind, and plan activities for the session!",
  emoji: "📚",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Bookbinding Workshop",
          emoji: "📚",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the bookbinding workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on book types to bind?",
            description:
              "What types of books should we create during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What book types should we choose?",
                emoji: "📖",
                completeAction: {
                  question: "Decide on materials needed?",
                  description:
                    "What materials should we gather for bookbinding?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What materials should we bring?",
                      emoji: "🧵",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Create Some Books!",
    outroDescription:
      "Your bookbinding workshop plans are set! Enjoy the crafting!",
  },
};
